import { deleteResource } from '../api/gas';
export default async (memberId, logger) => {
    return deleteResource(`member`, memberId, logger);
};
